/// <reference path="DOMAttached.js" />
/// <reference path="TextResource.js" />
/// <reference path="UrlTemplate.js" />

var SpellingFireServerInterface = null;

class SpellingFire extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.valueParameterName = "PLH_number";
		this.actionParameterName = "PLH_Action";
		SpellingFireServerInterface = this;
	}

	storeMusicVolume(volume, onSuccessCallback, onFailureCallback) {
		// Apparently there was a plan to store the volume here and then restore it when the game opens next time. However, this was never implemented.
	}

	storeSoundVolume(volume, onSuccessCallback, onFailureCallback) {
		// Apparently there was a plan to store the volume here and then restore it when the game opens next time. However, this was never implemented.
	}

	hasMemberEnoughMoney(onTrueCallback, onFalseCallback) {
		// action: 0 = check for enough money
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, 0).r(this.actionParameterName, 0).url, {
			method: 'get'
		}).then((response) => {
			var parsedResponse = response.data;

			if (parsedResponse.success) {
				onTrueCallback();
			} else {
				onFalseCallback();
			}
		});
	}

	callForMoneyTransaction(onSuccessCallback, onFailureCallback) {
		// action: 1 = book money now/request payment
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, 0).r(this.actionParameterName, 1).url, {
			method: 'get'
		}).then((response) => {
			// for now, we assume everything went okay
			// as we just checked if the user has enough money
		});
	}

	storeScore(score, onSuccessCallback, onFailureCallback) {
		// action: 2 = store score
		axios(new UrlTemplate(this.options.serverCommunicationURL).r(this.valueParameterName, score).r(this.actionParameterName, 2).url, {
			method: 'get'
		}).then((response) => {
			onSuccessCallback();
		});
	}

	storeCurrentLevel(level, onSuccessCallback, onFailureCallback) {
		// action: 1 = store current level
		axios(new UrlTemplate(this.options.spellingFireServerCommunicationURL).r(this.valueParameterName, level).r(this.actionParameterName, 1).url, {
			method: 'get'
		}).then((response) => {
			var parsedResponse = response.data;

			if (parsedResponse.response == 0) { // 0 = All good. Check Navigation.Node.AJAJ.Games.SpellingFire for enum.	
				onSuccessCallback();
			}
		});
	}

	storeMedal(medal, onSuccessCallback, onFailureCallback) {
		// action: 2 = store medal
		axios(new UrlTemplate(this.options.spellingFireServerCommunicationURL).r(this.valueParameterName, medal).r(this.actionParameterName, 2).url, {
			method: 'get'
		}).then((response) => {
			// Do nothing? Medal should be saved...
		});
	}

	getLevel(level, onSuccessCallback, onFailureCallback) {
		// 1 = getLevel
		axios(new UrlTemplate(this.options.spellingFireServerCommunicationURL).r(this.valueParameterName, level).r(this.actionParameterName, 1).url, {
			method: 'get'
		}).then((response) => {
			onSuccessCallback(response.data);
		});
	}

	storeScoops(amount, onSuccessCallback, onFailureCallback) { }
}
